import { makeStyles } from '@material-ui/core/styles';

import { COLORS } from 'src/data/ui';

export const useStyles = makeStyles(
  (theme) => ({
    root: {
      height: 56,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'start',
      gap: theme.spacing(1),
      padding: theme.spacing(2, 3),

      ...theme.typography.regular14,
      color: COLORS.gray.black,

      '&:hover': {
        backgroundColor: COLORS.gray.gray80,
      },
    },
    icon: {
      color: COLORS.gray.gray30,
      fontSize: theme.typography.pxToRem(24),
      '& rect': {
        fill: 'transparent',
      },
    },
  }),
  { name: 'ChannelButton' }
);
